<template>
    <div class="blockuser" v-if="seen">
        <div class="notify">
            <div>
                <span>
                    <svg width="120px"  height="120px"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-dual-ring" style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;"><circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed" stroke-dasharray="31.41592653589793 31.41592653589793"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>
                </span><br>
                <span>Logging out....</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'
import AuthenticationService from '../services/AuthenticationService'

export default {
  data () {
    return {
      seen: false
    }
  },
  methods: {
    ...mapMutations([
      'SET_DIRECTORY_CHILDREN',
      'SET_PATH'
    ]),
    logout () {
      this.seen = true
      let that = this

      let data = {
        token: cookies.getCookie('token')
      }

      AuthenticationService.logout(data).then(res => {
        if (res.data.data === true) {
          localStorage.removeItem('token')
          localStorage.removeItem('firstname')
          localStorage.removeItem('lastname')
          localStorage.removeItem('email')
          localStorage.removeItem('account_type')
          localStorage.removeItem('date_created')
          localStorage.removeItem('phone')
          localStorage.removeItem('country')
          localStorage.removeItem('db')
          localStorage.removeItem('current_directory')
          localStorage.removeItem('current_directory_id')
          localStorage.removeItem('email')
          localStorage.removeItem('name')
          sessionStorage.removeItem('status')
          cookies.removeCookie('token')
          cookies.removeCookie('regtoken')
          that.$router.push('/login')
          that.SET_DIRECTORY_CHILDREN([])
          that.SET_PATH([])
          // that.$refs.loading.close()
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
